<template id="gameroom">
  <div class="outer">
    <div class="middle">
      <div class="inner">
        <div class="text">
          <div class="headtext">
            <span>
              <img class="logoimg" src="../../assets/logo2.png" />
            </span>
            <h1 class="normal_text toptext"> Bugha cup</h1>
          </div>

          <div class="sectiontext">
            <h3 class="game_room_section">Looking for Teammate</h3>
          </div>

          <label class="normal_text"  v-if="lookingForTeamUsers.length == 0">{{ lookingForTeamUsersMsg }}</label>

          <div class="scroll_list">
            <tr class="normal_text" v-for="user in lookingForTeamUsers">
              <td class="normal_text">{{ user.username }}</td>
            </tr>
          </div>

          <!-- <div class="scroll_list" id="data">
            <tr class="normal_text innerlist" v-for="user in sorted">
              <td class="normal_text">{{ user.username }}</td>
            </tr>
          </div> -->

          <div class="sectiontext">
            <h3 class="game_room_section">Teamed up</h3>
          </div>
          <label class="normal_text" v-if="inGameUsers.length == 0"
            >Invited users are not yet in any team</label
          >
          <div class="scroll_list">
            <tr class="normal_text" v-for="user in inGameUsers">
              <td class="normal_text">{{ user.username }}</td>
            </tr>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
//https://stackoverflow.com/questions/41270522/populate-table-in-vue-template-component-from-rest-api

export default {
  mounted() {
    var inviteId = this.$route.query.invite_id;
    if (inviteId == null) {
      alert("Please add invite_id to the link");
    }
    var test = this.$route.query.test;


    this.getInvitedUsers(inviteId);
    this.startInterval(inviteId, test);

  },
  data: function () {
    return {
      message: "Invited Users List Row",
      invitedUsers: [],
      lookingForTeamUsers: [],
      inGameUsers: [],
      timer: "",
      lookingForTeamUsersMsg: "",
      // myuser: [],
      // sorted: [],
    };
  },
  computed: {
    login_status() {
      return this.$store.getters.login_status;
    },
    url() {
      return this.$store.getters.url;
    },
    status() {
      return this.$store.getters.step_1_status;
    },
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
  },
  methods: {
    startInterval: function (invite, test) {
        const self = this;
        const inviteId = invite;
        const isTest = test;
        setInterval(function() {
            console.log("Automatically updating data for invite id"+inviteId);
            if(isTest != null) {
              self.populateTestData();
            } else {
              self.getInvitedUsers(inviteId);
            }
        }, 10000)
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    getInvitedUsers(inviteId) {

      axios
        .get(
          "/" +
            this.url.service_name_auth +
            "/" +
            this.url.version_number +
            "/user/invited_user?master_token=6a259a34-f1c2-4930-8384-6ee8a39af7a4&invite_id=" +
            inviteId
        )
        .then((res) => {
          if (res.data.length > 0) {
            this.getExtraInformationForInvitedUsers(res.data);
          }
        })
        .catch((err) => {
          this.errors = err.response.data.message;
          this.loading = false;
          stop = true;
        });
    },
    getExtraInformationForInvitedUsers(userList) {
      console.log("Getting extra info for users");
      var idList = userList.map((user) => user.person_id);
      let params = {
        person_id: idList[0],
        person_ids: idList,
        fields: ["username", "status_changed_at"],
      };

      axios
        .post("/user/" + this.url.version_number + "/user/details", params)
        .then((res) => {
          var sortList = userList.map((user) => {
            user.username = res.data[user.person_id].username;
            user.status_changed_at = res.data[user.person_id].status_changed_at;
            return user;
          });
          userList = sortList.sort(function (x, y) {
            return (
              new Date(y.status_changed_at.toString()) -
              new Date(x.status_changed_at.toString())
            );
          });

          this.invitedUsers = userList;
          this.inGameUsers = userList.filter((user) => user.is_in_team);
          this.lookingForTeamUsers = userList.filter(
            (user) => user.is_online && user.is_visible && !user.is_in_team
          );
          if (this.lookingForTeamUsers.length == 0) {
            this.lookingForTeamUsersMsg = "Users are not yet looking for team";
          }
        })
        .catch((err) => {
          console.log(err);
          this.errors = err.response.data.message;
          this.loading = false;
          stop = true;
        });
    },
    populateTestData() {
      this.lookingForTeamUsers = [
        {
          username: "Test A",
          person_id: "62e673663",
          last_login_at: "2021-07-22T16:00:00",
          discord_id: 6768,
          epic_id: null,
          device_os: null,
          is_online: true,
          is_visible: false,
          is_in_team: true,
        },
        {
          username: "Test B",
          person_id: "62e673663",
          last_login_at: "2021-07-22T12:00:00",
          discord_id: 6768,
          epic_id: null,
          device_os: null,
          is_online: true,
          is_visible: false,
          is_in_team: true,
        },
        {
          username: "Test C",
          person_id: "62e673663",
          last_login_at: "2021-07-24T16:00:00",
          discord_id: 6768,
          epic_id: null,
          device_os: null,
          is_online: true,
          is_visible: false,
          is_in_team: true,
        },
        {
          username: "Test D",
          person_id: "62e673663",
          last_login_at: "2021-05-22T16:00:00",
          discord_id: 6768,
          epic_id: null,
          device_os: null,
          is_online: true,
          is_visible: false,
          is_in_team: true,
        },
        {
          username: "Test E",
          person_id: "62e673663",
          last_login_at: "2021-08-22T16:00:00",
          discord_id: 6768,
          epic_id: null,
          device_os: null,
          is_online: true,
          is_visible: false,
          is_in_team: true,
        },
        {
          username: "Test F",
          person_id: "62e673663",
          last_login_at: "2021-04-22T16:00:00",
          discord_id: 6768,
          epic_id: null,
          device_os: null,
          is_online: true,
          is_visible: false,
          is_in_team: true,
        },
        {
          username: "Test G",
          person_id: "62e673663",
          last_login_at: "2021-03-22T16:00:00",
          discord_id: 6768,
          epic_id: null,
          device_os: null,
          is_online: true,
          is_visible: false,
          is_in_team: true,
        },
        this.inGameUsers = this.lookingForTeamUsers
      ];
    }
  },
};
</script>

<style scoped>
#gameroom {
  background-color: transparent;
}

.normal_text {
  color: #ffffff;
  text-align: left;
  font-family: Blinker;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;

  max-width: 36rem;
}

.game_room_title {
  color: #ffd500;
  text-align: left;
  transition: color 0.1s linear;
}

.game_room_section {
  color: #ffd500;
  text-align: left;
  font-family: Blinker;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  transition: color 0.1s linear;
  padding-top: 2px;
}

.text {
  text-align: left;
  margin: left;
  width: 15.35rem;
  float: right;
  color: #ffffff;
}

.outer {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.inner {
  margin-left: auto;
  width: 400px;
}

.headtext {
  background-color: black;
  height: 35px;
  display: inline-flex;
  padding-left: 15px;
  border-radius: 10px;
}

.sectiontext {
  margin-top: 5px;
  background-color: black;
  height: 20px;
  width: 70%;
  /* display: inline-flex; */
  padding-left: 15px;
  border-radius: 2px;
}

.toptext {
  padding-top: 10px;
  padding-left: 5px;
  padding-right: 5px;
  color: #fffff9;
}

.scroll_list {
  height: 100px;
  overflow: scroll;
  overflow-anchor: none;
}
.scroll_list::-webkit-scrollbar {
  display: none;
}

.logoimg {
  height: -webkit-fill-available;
}

/* #box {
  width: 200px;
  height: 100px;
  overflow: scroll;
  margin: 0 10px 0;
  -webkit-animation-name: move;
  -webkit-animation-duration: 5s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-direction: up;
  -webkit-animation-timing-function: linear;
  margin-top: 50%;
}
#box:hover {
  -webkit-animation-play-state: paused;
}
@-webkit-keyframes move {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
} */
</style>